<template>
    <div class="mainFrame " :class="{isHiddenLeft:!isShowLeft}">
        <div class="headerBox"> 
            <div class="toggleMenu" @click="toggleLeft">
                <i class="el-icon-s-fold" v-show="isShowLeft"></i>
                <i class="el-icon-s-unfold" v-show="!isShowLeft"></i>
            </div>
            <myHeader :show-left="isShowLeft"></myHeader>
        </div>
        <transition name="el-zoom-in-top">
            <div class="leftMemuBox" v-show="isShowLeft">
                <myLeft></myLeft>
            </div>
        </transition>

        
        <div class="mainBox" :class="{testBg:environmental=='test',devBg:environmental=='dev'}" id="mainBox">
            <!-- <keep-alive>
				<router-view/>
			</keep-alive> --> 
            <breadCrump :isShowBack="isShowBack" :breadData="breadData" v-if="isShowBread"></breadCrump>
            <router-view />

        </div>
        <!-- <div class="footerBox">
			<myFooter></myFooter>
		</div> -->

    </div>
</template>

<script>
    import breadCrump from '@/components/breadCrump.vue'
    import myHeader from '@/components/headerComponent.vue'
    import myLeft from '@/components/leftComponent.vue'
    import myFooter from '@/components/footerComponent.vue'
    import {
        utils
    } from '@/common/common.js'
    export default {
        name: 'mainFrame',
        data() {
            return {
                environmental:'',
                msg: 'Welcome to Your Vue.js App',
                breadData: [],
                isShowBack: false,
                isShowBread: '',
                currentPath: '',
                isShowLeft:true,

            }
        },
        components: {
            myHeader,
            myLeft,
            myFooter,
            breadCrump
        },
        computed: {
            currentRouteKey() {
                // alert(1)
                var a = window.location.href
                let path = this.$route.meta.matchLeftKey
                console.log(this.$route, '当前路由-左菜单里面的显示111111111111111111')
                return path
            },
        },
        watch: {
            '$route': {
                immediate: true,
                handler: function(to, from) {
                    let _this = this
                    // console.log("路由变化------")
                    // console.log(to)
                    this.currentPath = to.path
                    let breadArr = to.matched ? to.matched : []
                    let result = []
                    breadArr.forEach(function(item, index) {
                        let buffer = {}
                        if (item.meta && item.meta.title) { // 遍历路径放在面包导航条中
                            buffer.text = item.meta.title
                            buffer.path = item.path
                            if (_this.currentPath == buffer.path) {
                                buffer.isCurrent = true
                            }
                            result.push(buffer)
                        }
                        if (index == breadArr.length - 1) { //判断是否显示返回按钮
                            if (item.meta && item.meta.isShowBack) {
                                _this.isShowBack = true
                            } else {
                                _this.isShowBack = false
                            }
                        }
                        if (index == breadArr.length - 1) { //判断是否显示面包屑
                            if (item.meta && item.meta.isShowBread) {
                                _this.isShowBread = true
                            } else {
                                _this.isShowBread = false
                            }
                        }

                    })
                    this.breadData = result
                },
            }
        },
        methods: {
            toggleLeft(){
                this.isShowLeft=!this.isShowLeft
            }

        },
        mounted() {
            this.environmental=utils.getCurrentApi()
            // console.log("刷线maainframe")
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .mainBox {
        min-width: 1140px;
    }
    .mainFrame.isHiddenLeft{
        .leftMemuBox{
            width:0;
        }
        .mainBox{
            left:0;
        }
    }
    .mainFrame {
        .headerBox {
            position: relative;
            z-index: 10;
            background: #fff;
            .toggleMenu{position: absolute; left: 180px; top: 0px; z-index: 12; padding:0 20px; height: 54px;
            color:#c0c4cc;font-size: 20px;line-height: 54px;cursor:pointer;}
        }

        .leftMemuBox {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            width: 180px;
            padding-top: 54px;
            box-sizing: border-box;
            background: #44094f url(../assets/images/pic/side_bar_bg.jpg) no-repeat top center/180px 768px;
            color: #fff;
            overflow-y:auto;
            
        }

        .mainBox {
            position: absolute;
            top: 54px;
            left: 180px;
            right: 0;
            bottom: 0rem;
            overflow: auto;
        }

        .footerBox {
            position: absolute;
            bottom: 0;
            left: 5.25rem;
            right: 0;
            background: #fff;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/mainFrame.vue